import { createBlueprint as e } from "@made-people/blueprint";
const s = e({
  slots: {
    base: "col-span-3",
    crumb: "text-label-sm text-text-less-emphasis-1 hover:text-black",
    divider: "text-label-sm text-text-less-emphasis-1 mx-0.5"
  },
  variants: {
    // @TODO: replace isOn variant with non-contextual variant or className prop
    isOn: {
      pdp: {
        base: "",
        crumb: ""
      }
    }
  }
});
export {
  s as breadcrumbsBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
